export default __webpack_public_path__ + "6bf3cf5d375d7561cb3b9bf74212ed45.png";